import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";
import { RateioGeralContaPagarLista } from "../../models/rateio_geral_contas_pagar_lista";
import { IGetAllRateioGeralContaPagarUseCase } from "../../../presentation/useCases/read/get_all_rateio_geral_conta_pagar_use_case";

/**
 * GetAllRateioGeralUseCase
 */

export class GetAllRateioGeralContaPagarUseCase extends BasePaginatedUseCase<RateioGeralContaPagarLista> implements IGetAllRateioGeralContaPagarUseCase {
  constructor(private readonly repository: IFinanceiroRepository) {
    super();
  }

  async getAllRateioGeralContaPagarLista(
    idsCentroCusto: number[],
    nroNotaFiscal?: string | null,
    dataDe?: Date | null,
    dataAte?: Date | null,

    currentPage?: number,
    rowsPerPage?: number

  ): Promise<void> {
    const result = await this.repository.getAllRateioGeralContaPagarLista(
      idsCentroCusto,
      nroNotaFiscal,
      dataDe,
      dataAte,
      currentPage ?? 1,
      rowsPerPage ?? 25,
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }

}
